import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTcfVendorsGet = {
    path: "/tcf/vendors",
    method: RouteHttpVerb.GET
};
export { locationRestTcfVendorsGet };
